import React from 'react';

import { useSearchFieldStates } from '../hooks/useSearchFieldStates';
import { transformSearchData } from '../utils/transform-data';

import { AritoIcon, AritoFormV2, DialogV2, HeaderTabsV2, BottomActionBarV2 } from '@/components/custom/erp';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import { initialValues, searchSchema } from '../schema';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = (data: BanHangPayload) => {
    const searchFieldData = searchFieldStates.getSearchFieldData();
    const transformedData = transformSearchData(data, searchFieldData);
    onSearch(transformedData);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Bảng kê công nợ theo hóa đơn'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab searchFieldStates={searchFieldStates} />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode={'search'} onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
